import React, { Component } from 'react';
import { BrowserRouter as Router, Switch , Route } from 'react-router-dom';
import appRoutes from "./routes";
const token = window.localStorage.getItem("token");
if(!token ) {
  if(window.location.pathname === '/' ) {
    //
  }

  else  {
    window.location.replace('/')
  }
}
class App extends Component {
  render() {
    return (
        <Router>
          <Switch>
            {
              appRoutes.map (route=>(
                  <Route key={route.id} exact path={route.path} component={route.component} />
              ))
            }
          </Switch>
        </Router>
    );
  }
}

export default App;